import http from '@/support/plugin/axios'

export const 

//Obter lista de jornal
getDigitalInlaysByCompanyId = (companyId) => http.get(`companies/${companyId}/digital-inlays`)